import React from 'react';
import { motion } from 'framer-motion';
import { CONFIG } from '../config';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiEye, FiMapPin } = FiIcons;

const SamplePages = ({ onPreview }) => {
  return (
    <div id="samples">
      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold text-white font-display mb-4">Exclusive Demo Previews</h2>
        <p className="text-slate-400 max-w-2xl mx-auto">
          Explore live demo previews across multiple industries. If your business is not shown, we can still build the same premium framework for your market.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {CONFIG.DEMO_SITES.map((demo, idx) => (
          <motion.div 
            key={demo.id} 
            initial={{ opacity: 0, scale: 0.95 }} 
            whileInView={{ opacity: 1, scale: 1 }} 
            viewport={{ once: true }} 
            transition={{ delay: idx * 0.05 }} 
            className="glass-card group cursor-pointer overflow-hidden border border-white/5" 
            onClick={() => onPreview(demo)}
          >
            <div className="relative h-40 overflow-hidden">
              <img 
                src={demo.imageUrl} 
                alt={`${demo.label} preview`} 
                className="w-full h-full object-cover opacity-60 group-hover:opacity-100 group-hover:scale-110 transition-all duration-700 ease-in-out" 
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#080a0d] to-transparent opacity-60" />
            </div>
            
            <div className="p-6">
              <div className="mb-4">
                <div className="text-blue-400 text-[9px] font-black uppercase tracking-[0.2em] mb-1">
                  {demo.industry}
                </div>
                <h3 className="text-lg font-bold text-white font-display leading-tight">{demo.label}</h3>
                <div className="flex items-center text-slate-500 text-[10px] mt-1">
                  <SafeIcon icon={FiMapPin} className="mr-1" /> {demo.location}
                </div>
              </div>
              
              <div className="pt-4 border-t border-white/5">
                <div className="flex items-center justify-between text-blue-400 text-xs font-bold group-hover:text-blue-300 transition-colors">
                  <span>Preview Live Page</span>
                  <SafeIcon icon={FiEye} className="text-lg" />
                </div>
                <p className="text-[9px] text-slate-600 mt-1 uppercase tracking-widest font-black">Opens instantly &bull; No navigation</p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default SamplePages;